import dayjs from 'dayjs';

import PDFTemplateClient from '../PDFExport/PDFTemplate';

interface IProps {
  items: { [key: string]: unknown }[];
  headers: {
    label: string;
    key: string;
  }[];
  fileName: string;
  isLandscape?: boolean;
  handleUploadFile?: (data: {
    fileContent: unknown;
    fileName: string;
    description: string;
  }) => void;
}
export function PDFtoBase64({
  items,
  headers,
  isLandscape = false,
  fileName,
  handleUploadFile
}: IProps) {
  const fileNameFormated = `${fileName}_${dayjs().format('DD_MM_YYYY')}`;
  const { pdfMake } = window;

  pdfMake
    .createPdf(
      PDFTemplateClient({
        data: items || [],
        headers,
        isLandscape,
        widthLength: items?.length
      })
    )
    .getBase64((data) => {
      handleUploadFile({
        fileContent: data,
        fileName: `${fileNameFormated}.pdf`,
        description: `Exportación de ${fileName} en formato PDF`
      });
    });
}
